(() => {
  'use strict';
  const init = () => {
    const root = document.getElementById('sc-reference');
    if (!root || root.dataset.scPurchaseInitialized === 'true') return;
    root.dataset.scPurchaseInitialized = 'true';
    const product = document.querySelector('product-info[data-product-id="15884221382729"]');
    if (!product) return;
    const sticky = root.parentElement.querySelector('.sc-product-sticky');
    const opener = () => Array.from(product.querySelectorAll('._rsi-buy-now-button')).find(button =>
      !button.closest('#_rsi-buy-now-button-floating') &&
      !button.closest('[role="dialog"]') &&
      button.getClientRects().length > 0 && getComputedStyle(button).display !== 'none'
    );
    const update = () => {
      if (!sticky) return;
      const primary = opener() || product.querySelector('product-form');
      const show = !!primary && matchMedia('(max-width:749px)').matches && primary.getBoundingClientRect().bottom <= 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', String(!show));
    };
    const forward = async event => {
      const trigger = event.target.closest('[data-sc-open-purchase]');
      if (!trigger || (!root.contains(trigger) && !sticky?.contains(trigger))) return;
      event.preventDefault();
      if (trigger.dataset.scOpening === 'true') return;
      trigger.dataset.scOpening = 'true';
      let button;
      try {
        for (let attempt = 0; attempt < 40; attempt++) {
          button = opener();
          if (button) break;
          await new Promise(resolve => setTimeout(resolve, 125));
        }
        if (button) button.click();
        else {
          product.querySelector('product-form')?.scrollIntoView({block:'center',behavior:'auto'});
          const notice = root.querySelector('[data-sc-purchase-notice]');
          if (notice) notice.textContent = 'Espera un momento y utiliza el botón de compra principal.';
        }
      } finally {
        delete trigger.dataset.scOpening;
        update();
      }
    };
    document.addEventListener('click', forward);
    window.addEventListener('scroll', update, {passive:true});
    window.addEventListener('resize', update);
    window.addEventListener('pageshow', update);
    new MutationObserver(update).observe(product, {childList:true,subtree:true});
    update();
    setTimeout(update, 1500);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
